import { Component, OnInit, OnDestroy } from '@angular/core';
import { timer, forkJoin, Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { FeedBackService } from '../../data/feedback.service';
import { FeedBackType } from '../../data/feedback-type';
import { trackEntityById } from 'projects/core/src/public-api';
import { ProjectFile } from '../../../project-misc/data/project/project-file';
import { HttpResponse, HttpEventType, HttpEvent } from '@angular/common/http';
import { MatSnackBarRef, SimpleSnackBar, MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-send-feed-back-dialog',
    templateUrl: './send-feed-back-dialog.component.html',
    styleUrls: ['./send-feed-back-dialog.component.scss']
})
export class SendFeedBackDialogComponent implements OnInit, OnDestroy {

    subjectString: string;

    message: string;

    feedBackType: FeedBackType;
    feedBackTypes: FeedBackType[] = []

    feedBackPriority: string;
    feedBackPriorities: string[] = []

    loadingSpinner = false;

    progressBar: number;

    trackEntityById = trackEntityById;

    files: File[] = []

    activeSnackBar: MatSnackBarRef<SimpleSnackBar>

    filePasteListener = null;

    constructor(
        private snackBar: MatSnackBar,
        protected dialogRef: MatDialogRef<SendFeedBackDialogComponent>,
        protected feedBackService: FeedBackService
    ) { }

    ngOnInit() {
        this.filePasteListener = (event: ClipboardEvent) => {
            this.onFilePaste(event)
        }

        document.addEventListener('paste', this.filePasteListener);

        this.feedBackService.getFeedBackTypes().subscribe(types => {
            this.feedBackTypes = types
            this.feedBackType = this.feedBackTypes[0]
        })

        this.feedBackService.getFeedBackPriorities().subscribe(priorities => {
            this.feedBackPriorities = priorities.reverse()
            this.feedBackPriority = this.feedBackPriorities[1]
        })

    }

    onFilePaste(event: ClipboardEvent) {
        const items = (event.clipboardData).items;
        // tslint:disable-next-line: forin
        for (const index in items) {
            const item = items[index];
            if (item.kind === 'file') {
                const file = item.getAsFile();
                this.files.push(file)
            }
        }
    }

    uploadFile(files: File[], filesForm?) {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < files.length; i++) {
            this.files.push(files[i])
        }
        filesForm.clear();
    }

    deleteFile(file: File) {

        const index = this.files.indexOf(file, 0);
        if (index > -1) {
            this.files.splice(index, 1);
        }

    }

    saveFeedBack() {
        this.loadingSpinner = true;


        const feedBackData = {
            attachments: [],
            subject: this.subjectString,
            body: this.message,
            type: this.feedBackType.value,
            priority: this.feedBackPriority
        }


        if (this.files.length > 0) {
            const obsArray: Observable<HttpEvent<string>>[] = []
            this.files.forEach(file => {
                obsArray.push(this.feedBackService.sendFeedBackFiles([file]))
            })

            forkJoin(obsArray).subscribe(events => {
                events.forEach(feedBackEvent => {
                    if (feedBackEvent.type === HttpEventType.Response) {
                        const feedBackResponce = feedBackEvent as HttpResponse<string>
                        feedBackData.attachments.push(feedBackResponce.body[0])

                    }
                })
                this.saveData(feedBackData)
            }, error => {
                this.loadingSpinner = false
                this.openSnackBar(error.message)
            })
        }

        else {
            this.saveData(feedBackData)
        }

    }

    saveData(feedBackData) {
        this.feedBackService.sendFeedBack(feedBackData).subscribe(emit => {
            this.loadingSpinner = false
            this.dialogRef.close();
        })
    }

    openSnackBar(message: string, duration = 5000) {
        if (this.activeSnackBar) {
            this.activeSnackBar.dismiss();
        }

        this.activeSnackBar = this.snackBar.open(message, '', {
            duration,
            panelClass: 'file-error-snackbar',
            verticalPosition: 'top',
        });
    }

    ngOnDestroy() {
        document.removeEventListener('paste', this.filePasteListener)
    }

}
